import {notification} from 'ant-design-vue';

export function methodCallback(parameter) {
    if (parameter.data.code === "EXCEPTION") {
        notification.error({
            message: '错误！',
            description: "异常信息",
            duration: 2,
            key: "1",
            top: '20px',
        });
    } else if (parameter.data.code === "VERIFICATION_CODE_SEND") {
        notification.success({
            message: '提示！',
            description: "验证码已发送",
            duration: 2,
            key: "2",
            top: '20px',
        });
    } else if (parameter.data.code === "VALIDATION_FAILED") {
        notification.warning({
            message: '警告！',
            description: "用户名或密码错误",
            duration: 2,
            key: "3",
            top: '20px',
        });
    } else if (parameter.data.code === "IMAGE_VERIFICATION_CODE_ERROR") {
        notification.warning({
            message: '警告！',
            description: "图片验证码错误",
            duration: 2,
            key: "4",
            top: '20px',
        });
    } else if (parameter.data.code === "INVALID_VERIFICATION_CODE") {
        notification.warning({
            message: '警告！',
            description: "图片验证码无效或已过期",
            duration: 2,
            key: "5",
            top: '20px',
        });
    } else if (parameter.data.code === "VERIFICATION_CODE_SEND_FAIL") {
        notification.warning({
            message: '警告！',
            description: "验证码发送失败",
            duration: 2,
            key: "6",
            top: '20px',
        });
    } else if (parameter.data.code === "INVALID_PHONE_VERIFICATION_CODE") {
        notification.warning({
            message: '警告！',
            description: "手机验证码过期或无效",
            duration: 2,
            key: "7",
            top: '20px',
        });
    } else if (parameter.data.code === "PHONE_VERIFICATION_CODE_ERROR") {
        notification.warning({
            message: '警告！',
            description: "手机验证码错误",
            duration: 2,
            key: "8",
            top: '20px',
        });
    } else if (parameter.data.code === "PHONE_FORMAT_ERROR") {
        notification.warning({
            message: '警告！',
            description: "当前手机号格式不正确",
            duration: 2,
            key: "9",
            top: '20px',
        });
    } else if (parameter.data.code === "NOT_FOUND_DATA") {
        notification.warning({
            message: '警告！',
            description: "未找到对应的数据",
            duration: 2,
            key: "31",
            top: '20px',
        });
    } else {
        notification.warning({
            message: '警告！',
            description: "系统错误,请联系管理员",
            duration: 2,
            key: "31",
            top: '20px',
        });
    }
}